import { AccountShopsResponse } from "api/models";
import { apiClient } from "../utils";

export const getShopList = async (): Promise<AccountShopsResponse> => {
  const { data } = await apiClient.get<AccountShopsResponse>("account/shops");
  return data;
};
